import {Component, inject, OnInit, signal, WritableSignal} from '@angular/core';
import {CompanyService} from '@services/company.service';
import {CompanyRouteContextService} from '@services/company-route-context.service';
import {DatePipe} from '@angular/common';
import {ICompanyNotification} from '@models/workspace.interface';

@Component({
  selector: 'app-company-notifications',
  imports: [DatePipe],
  templateUrl: './company-notifications.html'
})
export class CompanyNotifications implements OnInit {
  private readonly companyService = inject(CompanyService);
  private readonly routeContext = inject(CompanyRouteContextService);

  loading: WritableSignal<boolean> = signal(false);
  notifications: WritableSignal<ICompanyNotification[]> = signal([]);

  ngOnInit(): void {
    this.loadNotifications();
  }

  loadNotifications(): void {
    const siret = this.routeContext.currentSiret();
    if (!siret) return;
    this.loading.set(true);
    this.companyService.getNotifications(siret).subscribe({
      next: (value) => {
        this.notifications.set(value);
        this.loading.set(false);
      },
      error: () => this.loading.set(false),
    });
  }

  markAsRead(notification: ICompanyNotification): void {
    if (notification.read) return;
    this.companyService.markNotificationRead(notification.id).subscribe({
      next: () => this.loadNotifications(),
    });
  }
}
